import TopicLogs from './TopicLogs';

export default TopicLogs;
